import './modalWrapper.scss';

import UN from '../../.././assets/images/icons/unauthorized.png';

import React, { FunctionComponent } from 'react';
import { useAppDispatch } from '../../../features';
import { setIsRegistered, setModalSignInUp } from '../../../store/AppSlice';
import { modalTypeEnum } from '../../../types/modal';
import { useNavigate } from 'react-router-dom';
import { setModalErrorMessage } from '../../../store/NotificationSlice';

interface ModalUnauthorizedProps {
    message: string;
}

export const ModalUnauthorized: FunctionComponent<ModalUnauthorizedProps> = ({message}) => {

    const isComingFromUrl = window.location.href.includes('invite=');

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const label = isComingFromUrl ? "Fechar" : "Logar-se";

    const handleClick = () => {

        dispatch(setModalErrorMessage(''));

        if (!isComingFromUrl) {

            navigate('/home');
            dispatch(setIsRegistered(true));
            
            if (localStorage.getItem('aTEncrypted')) {
                dispatch(setModalSignInUp(modalTypeEnum.deviceLogin))
            } else {
                dispatch(setModalSignInUp(modalTypeEnum.register))
            }
            
        } else {
            dispatch(setModalSignInUp(modalTypeEnum.none))
        }
    }

    return (
        <div className="modal modal401">
            <div className="img">
                <img src={UN} alt="" />
            </div>
            <div className="title">
                Usuário não autorizado
                <small>
                    Por favor, refazer o login. O Token expirou ou a sessão é inválida. Você terá que logar-se novamente para poder voltar a utilizar o APP.
                </small>
            </div>
            <div className="title dashed">
                Motivo
            </div>
            <div className="message">
                {message}
            </div>

            <button className="button" onClick={handleClick}>
                {label}
            </button>

        </div>
    )
}